<template>
    <div class="container-fluid">
        <a class="navbar-brand" href="/">
            <img v-if="openMenu" :src="logoWide" alt="" width="110" class="d-inline-block align-text-top">
            <img v-else :src="logo" alt="" width="30" class="d-inline-block align-text-top">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon" @click="$emit('clicked')"></span>
        </button>
        <div v-bind:class="{'show': openMenu}" class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <!--                            <li class="nav-item">-->
                <!--                                <a class="nav-link" href="#">Informatie voor PTs</a>-->
                <!--                            </li>-->
                <!--                            <li class="nav-item">-->
                <!--                                <a class="nav-link" href="#">Pricing</a>-->
                <!--                            </li>-->
                <!--                            <li class="nav-item">-->
                <!--                                <a class="nav-link disabled">Disabled</a>-->
                <!--                            </li>-->

                <li class="nav-item">
                    <a class="nav-link" href="/kracht-conditie-training">Kracht & conditie-training</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/personal-training">Personal training</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/coaches">Onze coaches</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/abonnementen">Abonnementen</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/huisregels">Huisregels</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/faq">FAQ</a>
                </li>
<!--                <li class="nav-item">-->
<!--                    <a class="nav-link" href="/franchise">Als franchise</a>-->
<!--                </li>-->
                <li class="nav-item">
                    <a class="nav-link" href="/fotos">Foto's</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="/reviews">Reviews</a>
                </li>
<!--                <li class="nav-item">-->
<!--                    <a class="nav-link" href="/account/subscriptions/new">Inschrijven</a>-->
<!--                </li>-->
            </ul>
            <ul class="navbar-nav">
                <rondleiding-button size="sm" margins="" color-class="btn-outline-dark"></rondleiding-button>
            </ul>
            <ul class="navbar-nav list-inline">
                <div class="nav-link">
                    <a class="d-inline text-dark p-2" href="https://instagram.com/privategym_nl" target="_blank">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a class="mt-2 text-dark p-2" href="https://wa.me/+31649672871?text=Ik%20zou%20graag%20wat%20meer%20informatie%20willen%20over%20Private%20Gym" rel="nofollow" target="_blank">
                        <i class="fab fa-whatsapp"></i>
                    </a>

                </div>
                <!-- Icons -->
            </ul>
        </div>
    </div>
</template>

<script>

import RondleidingButton from "../Index/RondleidingButton";
export default {
    components: {RondleidingButton},

    props: {
        'openMenu': {default: false},
        'darkLogo': {default: true},
    },

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        logo() {
            if(this.darkLogo) {
                return '/images/pg-logo-s.png';
            }
            return '/images/pg-logo-s-white.png';
        },
        logoWide() {
            if(this.darkLogo) {
                return '/images/pg-logo-wide-s.png';
            }
            return '/images/pg-logo-wide-white.png';
        },
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {

    },

    watch: {
        //
    }
};
</script>
<style scoped>
.navbar-dark .navbar-toggler {
    color: rgba(0, 0, 0, 0.55);
    border-color: rgba(0, 0, 0, 0.1);
}
.navbar-dark .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255 ,255, 255, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
.navbar-light .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}
.navbar-toggler {
    border: none;
}
</style>
